import React, { useContext, useEffect, useRef } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useTranslation } from "react-i18next";

import { LayoutContext, ILayoutContext, DialogModesEnum } from '@uderly/react-uderly-ui';
import IqSpaceApi from '../../api/IqSpace';

export interface PlaylistWizardProps {
	playlistId: number;
	onPerformed: (response: any) => void;
	disabled?: boolean;
}

const PlaylistWizard = ({ disabled, playlistId, onPerformed }: PlaylistWizardProps) => {
	const { t } = useTranslation();

	const layoutContext = useContext(LayoutContext) as ILayoutContext;

	const defaultCount = 10;
	const count = useRef(defaultCount);

	const onAddQuestions = async () => {
		var request = {
			clear_playlist: false,
			language_id: 1,
			image_questions_count: Math.round(count.current / 10),
			questions_count: count.current,
		};

		const response = await IqSpaceApi.PopulatePlaylist(playlistId, request);

		if (response && response.status === 202) {
			onPerformed(response);
		} else {
			console.error(response);
		}
	}

	const AddQuestionsDialog = ({ onChanged }: { onChanged(v: number): void }) => {
		const [count, setCount] = React.useState<number>(defaultCount);

		useEffect(() => { onChanged(count); }, [count, onChanged]);

		const handleChange = (event: SelectChangeEvent<typeof count>) => {
			setCount(parseInt(event.target.value as string));
		};

		return <>
			<p>{t('playlist-wizard-desc')}</p><br />

			<FormControl fullWidth>
				<InputLabel id="questions-count-select-label">{t('questions-count')}</InputLabel>
				<Select
					labelId="questions-count-select-label"
					value={count}
					label={t('questions-count')}
					onChange={handleChange}>
					<MenuItem value={5}>5</MenuItem>
					<MenuItem value={10}>10</MenuItem>
					<MenuItem value={25}>25</MenuItem>
					<MenuItem value={50}>50</MenuItem>
				</Select>
			</FormControl>
		</>;
	}

	return <Tooltip title={t('playlist-wizard')} onClick={() => {
		count.current = defaultCount;

		layoutContext.dialog.show({
			title: t('playlist-wizard'),
			content: <AddQuestionsDialog onChanged={v => { count.current = v; }} />,
			mode: DialogModesEnum.confirmation,
			onConfirm: onAddQuestions
		});
	}}>
		<IconButton aria-label="populate" disabled={disabled}>
			<AutoFixHighIcon />
		</IconButton>
	</Tooltip>;
}

export default PlaylistWizard;